export const formatLanguageCode = (code: string): string => {
	const languages: Record<string, string> = {
		de: 'Deutsch',
		en: 'Englisch'
	};
	return languages[code] || code;
};
